var _apiRoots;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { pipe } from "ramda";
var DEVELOPMENT = "development",
  IEVM = "ievm",
  TEST = "test",
  QA = "qa",
  PROD = "prod";
var hostnames = {
  localhost: DEVELOPMENT,
  "10.0.2.2": IEVM,
  "test.": TEST,
  "test1.": TEST,
  "local.": TEST,
  "qa.": QA
};
var apiRoots = (_apiRoots = {}, _defineProperty(_apiRoots, DEVELOPMENT, "https://api.test.financialwellness.com"), _defineProperty(_apiRoots, IEVM, "https://api.test.financialwellness.com"), _defineProperty(_apiRoots, TEST, "https://api.test.financialwellness.com"), _defineProperty(_apiRoots, QA, "https://api.qa.financialwellness.com"), _defineProperty(_apiRoots, PROD, "https://api.financialwellness.com"), _apiRoots);
var getEnvKey = function getEnvKey(host) {
  return Object.keys(hostnames).find(function (key) {
    return host.includes(key);
  });
};
var getEnvironment = function getEnvironment(envKey) {
  return hostnames[envKey] || PROD;
};
var getApiRoot = function getApiRoot(environment) {
  return apiRoots[environment];
};
var apiRoot = pipe(getEnvKey, getEnvironment, getApiRoot);
export default apiRoot;